import money from "../../../assets/money.png";
import bullish from "../../../assets/bullish.png";
import wallet from "../../../assets/wallet.png";
export const getFloatRequestSummary = (coa,cor,tfu,fr,bu) => {
  return [
    {
      title: "Cost of Acquisition",
      value: coa || 0,
      icon: money,
      isPercentage: false,
    },
    {
      title: "Cost of Retention",
      value: cor || 0,
      icon: money,
      isPercentage: false,
    },
    {
      title: "Total Float Utilised",
      value: tfu || 0,
      icon: money,
      isPercentage: false,
    },
    {
      title: "Float ROI",
      value: fr || 0,
      icon: bullish,
      isPercentage: true,
    },
    {
      title: "Budget Utilisation",
      value: bu || 0,
      icon: wallet,
      isPercentage: true,
    },
  ];
};

export const floatDistributionData = [
  {
    title: "Regular Float",
    value: "₦1.8M (75%)",
    color: "#008A00",
  },
  {
    title: "Promotional Items",
    value: "₦400K (16.7%)",
    color: "#0041AC",
  },
  {
    title: "Perishables",
    value: "₦200K (8.7%)",
    color: "#EAAC30",
  },
  {
    title: "Zero-Value Visits",
    value: "24 Visits",
    color: "#8B5CF6",
  },
];

export const FilterByStatus = [
  {
    name: "Approved",
    filter: 0,
  },
  {
    name: "Pending",
    filter: 1,
  },
  // {
  //   name: "Declined",
  //   filter: 7,
  // },
  {
    name: "Rejected",
    filter: 4,
  },
];
